import { useContext } from 'react'
import { ModalContext } from 'containers/ModalManager'
import { ErrorHandler } from 'modules/tracing'
import { useHistory } from 'react-router-dom'
import { routes } from 'constants/routes'
import SignInWithPasswordModal from '../modals/SignInWithPasswordModal'
import { mapSsoStartUrl } from './mapSsoStartUrl'

export type SignInWithPasswordUser = {
  name: string
  email: string
  avatarSrc: string
  isGuestWorkspace?: boolean
}

interface SignInWorkspace {
  workspaceId: string
  workspaceName: string
  ssoEnabled?: boolean
  ssoStartUrl?: string
}

export const useSignInToUnauthorizedWorkspace = () => {
  const { showModal } = useContext(ModalContext)
  const history = useHistory()

  const signInToPersonalAccount = ({
    workspaceName,
    user,
    onCompleted,
  }: {
    workspaceName: string
    user: SignInWithPasswordUser
    onCompleted: () => void
  }) => {
    showModal(SignInWithPasswordModal, {
      workspaceName,
      name: user.name,
      email: user.email,
      avatarSrc: user.avatarSrc,
      onCompleted,
    })
  }

  const signIn = (
    workspace: SignInWorkspace,
    user: SignInWithPasswordUser,
    redirectBackToCurrentUrl: boolean
  ) => {
    const { workspaceId, workspaceName, ssoEnabled, ssoStartUrl } = workspace

    if (ssoEnabled && !ssoStartUrl) {
      ErrorHandler.shouldNeverHappen(
        `Workspace with id ${workspaceId} is configured with SSO but does not have any ssoStartUrl field.`
      )
      return
    }

    if (ssoEnabled && !user.isGuestWorkspace) {
      window.location.href = mapSsoStartUrl(ssoStartUrl!, {
        from: redirectBackToCurrentUrl ? history.location.pathname : undefined,
      })
    } else {
      signInToPersonalAccount({
        workspaceName,
        user,
        onCompleted: () => {
          history.push(routes.WORKSPACE_SHARES.create({ workspaceId }))
        },
      })
    }
  }

  return {
    signInToPersonalAccount,
    signIn,
  }
}
